import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Queue } from 'api/types';
import { AddPoolState } from 'components/drawers/add-pool-drawer/add-pool-state/add-pool-state.service';
import { PoolNameErrorHandler } from 'components/drawers/add-pool-drawer/pool-name-error-handler/pool-name-error-handler.class';
import { UTC_TIMES } from 'data/utc-times';
import { AddUTCToTimePipe } from 'pipes/add-utc-to-time.pipe';
import { TranslationKey } from 'pipes/translate.pipe';
import { SuppressErrorMatcher } from 'utils/error-matchers/suppress.error-matcher';
import { formatQueueDisplay } from 'utils/format-queue';
import { invalidCharactersValidator } from 'utils/validators/invalid-characters.validator';

@Component({
  selector: 'app-underutilization-form',
  standalone: false,
  templateUrl: './underutilization-form.component.html',
  styleUrl: './underutilization-form.component.scss'
})
export class UnderutilizationFormComponent implements OnInit {
underutilization!:FormGroup;
  @Output() public success = new EventEmitter<any>();
   @Output() public formdata = new EventEmitter<any>();
   @Output() getformStatus = new EventEmitter()
 public suppressErrorState = new SuppressErrorMatcher();
public getQueueDisplay = formatQueueDisplay;
checkformValidation:any;
constructor(public fb:FormBuilder,private addPoolState: AddPoolState,
  private addUTCToTimePipe: AddUTCToTimePipe){}
  public utcStartTimes = [...UTC_TIMES];
  ngOnInit(): void {
    this.underutilization=this.fb.group({
     alertname:['',[Validators.required,invalidCharactersValidator]],
     Queue:['',Validators.required],
     Time:['',Validators.required],
     executive:['',Validators.required],
     Email:['',Validators.required]
    })

    this.underutilization.valueChanges.subscribe((ele:any)=>{
      
      if(this.underutilization.valid){
        this.success.emit(this.underutilization.value)
      }
      else{
          this.success.emit(null)
      }
      
    })
     this.getformStatus.emit(false)
  }

  ngAfterViewInit(){
    this.checkformValidation=this.underutilization.getRawValue();
    this.underutilization.valueChanges.subscribe((ele: any) => {
        if (JSON.stringify(this.checkformValidation) !== JSON.stringify(this.underutilization.getRawValue())) {
          this.getformStatus.emit(true);
        }else {
          this.getformStatus.emit(false);  
        }
    })
  }

  public addUTCToTime(time: string): string {
    return this.addUTCToTimePipe.transform(time);
  }

  public get queues(): Queue[] {
    return this.addPoolState.queues;
  }

   public get poolNameErrorMatcher(): PoolNameErrorHandler {
      return this.addPoolState.poolNameErrorHandler;
    }
  
    public poolNameErrorMessageKey(): TranslationKey {
      return 'error.invalidCharacter';
    }
  
}
